import clsx from "clsx";

const InputCheckbox = ({ className, id, hasError, register, rules, children }) => (
  <div className={clsx("flex w-full space-x-3", className)}>
    <input
      {...register(id, rules)}
      type="checkbox"
      id={id}
      className={clsx(
        "h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-full bg-white outline outline-1 checked:border-2 checked:border-white checked:bg-blue",
        hasError ? "outline-red" : "outline-blue"
      )}
    />
    <label htmlFor={id} className={clsx(hasError && "text-red")}>
      {children}
    </label>
  </div>
);

export default InputCheckbox;
